import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-life-event-dialog',
  templateUrl: './life-event-dialog.component.html',
  styleUrls: ['./life-event-dialog.component.scss'],
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class LifeEventComponent implements OnInit {
  dialogRef = inject<MatDialogRef<LifeEventComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  lifeEvent = { type: null, date: new Date(), note: '' };

  ngOnInit() {}

  cancel() {
    this.dialogRef.close({ data: 'cancel' });
  }

  save() {
    // this.ses.takeDailyAction(this.data.id, this.action.type, this.data.bridge).subscribe(x => { });
    // if(this.form.valid) {
    // this.lifeEvent.date = this.lifeEvent.date.toLocaleDateString("en-US")
    this.dialogRef.close({ data: this.lifeEvent });
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
    // }
  }
}
